import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../components/Form/Field'
import Step from '../../../../../../features/components/Forms/StepForm/Step'
import Spoiler from '../../../../../../components/Spoiler'

import { CAMPAIGN } from '../../fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../../hooks/formHooks/listItemFormHooks/fields'

const stepFields = [CAMPAIGN]

const CampaignSelectionStep = ({
  formik,
  handleStepChange,
  additionalStepFields = [],
  existedCampaigns,
  showContinueButton = false,
  children,
  advancedSettingsChildren,
  topChildren
}) => {
  const { t } = useTranslation()

  const { setFieldValue, values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange([...stepFields, ...additionalStepFields])
  }, [handleStepChange, additionalStepFields])

  return (
    <Step
      stepTitle="Which campaign should the ad be uploaded to?"
      handleContinue={showContinueButton ? handleContinue : null}
    >
      {topChildren && topChildren}
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_existing_campaign"
        name={LIST_ITEM_OPTION}
        label={t('An existing campaign')}
        value={OPTION_EXISTING_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      >
        <p>{t('Please select which campaign to upload the new ad to.')}</p>
        <Field formik={formik} name={CAMPAIGN} placeholder={t('Campaign')} options={existedCampaigns} portaled={true} />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_new_campaign"
        name={LIST_ITEM_OPTION}
        label={t('A new campaign')}
        value={OPTION_NEW_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      >
        {children}
      </RadioBlock>

      {advancedSettingsChildren && <Spoiler title={t('Advanced Settings')}>{advancedSettingsChildren}</Spoiler>}
    </Step>
  )
}

CampaignSelectionStep.propTypes = {
  showContinueButton: PropTypes.bool,
  additionalStepFields: PropTypes.array,
  existedCampaigns: PropTypes.array,
  formik: PropTypes.object.isRequired,
  handleStepChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  advancedSettingsChildren: PropTypes.node
}

export default CampaignSelectionStep
